import { graphql } from "@/lib/gql/__generated__/gql";

/**
 * 日別料金一覧。行の組み立ては Query.rateMatrix が正本。
 */
export const PlanRateMatrix_Query = graphql(/* GraphQL */ `
	query PlanRateMatrix($hotelID: ID!, $startDt: String!, $endDt: String!, $adultNum: Int!) {
		rateMatrix(hotelID: $hotelID, startDt: $startDt, endDt: $endDt, adultNum: $adultNum) {
			id
			hotelID
			maxAdultNum
			headers {
				date
				weekday
			}
			items {
				id
				planID
				planName
				isSCConnected
				isDayTrip
				roomID
				roomName
				isDummyRoom
				salePeriodLabel
				dailyCells {
					date
					guestCells {
						adultNum
						cell {
							status
							priceYen
							displayLabel
						}
					}
				}
			}
		}
		roomList(hotelID: $hotelID) {
			rooms {
				roomID
				name
				inSale
			}
			dummy {
				roomID
				name
				inSale
			}
		}
	}
`);
